module.exports = __webpack_public_path__ + "static/traindex-main-image-844a11b3ac5f3997bca30e7ebe944aee.png";